/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridApi } from 'ag-grid-community';

import { getClientLocalStorageItem } from '../../localStorage';

export const setColumnStateByLocalStorage = ({
  clientId,
  saveGridStateId,
  gridApi,
}: {
  clientId: string;
  saveGridStateId?: string;
  gridApi: GridApi | null;
}) => {
  const gridState = getClientLocalStorageItem({
    clientId,
    clientDetailKey: saveGridStateId as string,
  });

  if (!gridState || !gridApi) {
    return;
  }

  if (gridState.filters) {
    gridApi.setFilterModel(gridState.filters);
  }

  if (gridState.columns) {
    (gridApi as any).applyColumnState({
      state: gridState.columns,
      applyOrder: true,
    });
  }
};
